import { Deserializable } from './deserializable';
import { TagEntry } from './TagEntry';
import { BehaviorSubject, Subject } from 'rxjs';

export class Signaltag implements Deserializable {
    customerTagAlias: string;
    dataSourceId: number;
    datasourceName: string;
    engUnit: string;
    engUnitsId: number;
    isExternal: boolean;
    rangeMax: number;
    rangeMin: number;
    step: boolean;
    tagAlias: string;
    tagDescription: string;
    tagId: number;
    tagIndexId: number;
    tagName: string;
    tagType: string;
    tagTypeId: number;
    ldsMeta: any | {tag: string};
    realTimeTimeout;
    realTime = false;
    isEvent = false;
    lastValue: number;
    lastTimeStamp: string | number;
    operationalProfile: {
        definition: string
    };
    trendExplorer = {
        added: false,
        chartSerieRef: null,
        traceColor: null,
        lastValue: null,
        lastTimeStamp: null,
        dataSubscription: null,
        recentlyAdded: false,
        loading: false,
        streamSub: null,
        dataSub: null,
        buffer: [],
        traceIndex: null,
        change: null,
        visible: true
    };
    opBuffer: TagEntry[] = [];

    timeZone: string;

    txBuffer = [];
    txBufferEvent = new Subject<boolean>();

    get displayName() {
        return this.tagName;
    }

    deserialize(raw: any): this {
        Object.assign(this, raw);
        return this;
    }

    setTxChartRef(ref) {
        this.trendExplorer.chartSerieRef = ref;
        this.trendExplorer.traceColor = ref.color;
    }

    resetTx() {
        this.trendExplorer.added = false;
        this.trendExplorer.traceColor = null;
        this.trendExplorer.traceIndex = null;
        this.trendExplorer.loading = false;
        this.trendExplorer.lastValue = null;
        this.trendExplorer.lastTimeStamp = null;
    }

    getLdsMatcher() {
        return this.tagAlias;
    }


}


// WEBPACK FOOTER //
// ./src/app/models/OPTag.ts